import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w100 mb20" }
const _hoisted_2 = {
  key: 0,
  class: "w100"
}
const _hoisted_3 = {
  key: 0,
  class: "fl w30 pad10"
}
const _hoisted_4 = { class: "fw600 pad10" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, " 通知先のURLを入力することで、調整ページのイベントが発生した際に、イベントを指定のURLにPushします。 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "fl w30 pad10"
}
const _hoisted_9 = { class: "fw600 pad10" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, " 通知先のURLを入力することで、調整ページのイベントが発生した際に、イベントを指定のSlackチャンネルにPushします。 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 2,
  class: "fl w30 pad10"
}
const _hoisted_14 = { class: "fw600 pad10" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, " 通知先のURLを入力することで、調整ページのイベントが発生した際に、イベントを指定のTeamsチャンネルにPushします。 ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = {
  key: 3,
  class: "fl w30 pad10"
}
const _hoisted_19 = { class: "fw600 pad10" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, " 通知先のURLを入力することで、調整ページのイベントが発生した際に、イベントを指定のTeamsチャンネルにPushします。 ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = {
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_24 = {
  class: "fl",
  style: {"width":"280px"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = ["for"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "fl w100 mt20"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "検証用トークン:  ", -1)
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FlashNotice),
    (_ctx.notiDic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.provider == `webhook`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h5", _hoisted_4, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/antena.png`),
                    width: "26",
                    height: "26",
                    class: "pointer fl mr10",
                    style: {"margin-top":"-8px"}
                  }, null, 8, _hoisted_5),
                  _createTextVNode(" Webhookで通知を受け取る ")
                ]),
                _hoisted_6,
                _hoisted_7
              ]))
            : (_ctx.provider == `slack`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("h5", _hoisted_9, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/logo/slack.png`),
                      width: "26",
                      height: "26",
                      class: "pointer fl mr10",
                      style: {"margin-top":"-8px"}
                    }, null, 8, _hoisted_10),
                    _createTextVNode(" Slackで通知を受け取る ")
                  ]),
                  _hoisted_11,
                  _hoisted_12
                ]))
              : (_ctx.provider == `teams`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("h5", _hoisted_14, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/logo/microsoft-teams.png`),
                        width: "26",
                        height: "26",
                        class: "pointer fl mr10",
                        style: {"margin-top":"-8px"}
                      }, null, 8, _hoisted_15),
                      _createTextVNode(" Teamsで通知を受け取る（Microsoftの仕様変更により終了予定となります） ")
                    ]),
                    _hoisted_16,
                    _hoisted_17
                  ]))
                : (_ctx.provider == `workflows_teams`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("h5", _hoisted_19, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/logo/microsoft-teams.png`),
                          width: "26",
                          height: "26",
                          class: "pointer fl mr10",
                          style: {"margin-top":"-8px"}
                        }, null, 8, _hoisted_20),
                        _createTextVNode(" Workflows Teamsで通知を受け取る ")
                      ]),
                      _hoisted_21,
                      _hoisted_22
                    ]))
                  : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_MdTextfieldTag, {
                fieldStyle: "min-width:280px;max-width:100%;",
                style: {"height":"56px","min-width":"280px","max-width":"100%"},
                class: "fl fs16",
                type: `AstagName`,
                placeholder: `${_ctx.placeholderWebhookUrl()}`,
                value: _ctx.notiDic.settings.webhook_url,
                onInputValue: _ctx.inputWebhookUrl,
                required: ""
              }, null, 8, ["placeholder", "value", "onInputValue"])
            ]),
            _hoisted_25,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableEvents, (timing_dic) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${_ctx.provider}_${timing_dic.timing}`,
                class: "fl mr20",
                style: {"width":"180px","margin-top":"25px"}
              }, [
                _createVNode(_component_CheckboxTag, {
                  value: `${timing_dic.timing}`,
                  name: `${timing_dic.timing}`,
                  checked: _ctx.notiDic.events?.includes(timing_dic.timing),
                  prefix: `${_ctx.provider}`,
                  onClickCheckbox: _ctx.clickTiming
                }, null, 8, ["value", "name", "checked", "prefix", "onClickCheckbox"]),
                _createElementVNode("label", {
                  for: `${_ctx.provider}_${timing_dic.timing}`,
                  class: "ml5 fs12 fw600 pointer"
                }, _toDisplayString(timing_dic.name), 9, _hoisted_26)
              ]))
            }), 128)),
            _hoisted_27,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "submit",
                class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                style: {"height":"50px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.upsertCustomNotification && _ctx.upsertCustomNotification(...args)))
              }, " 更新 "),
              _createElementVNode("button", {
                type: "submit",
                class: "fl pointer centered circle_button with_white_bg fs14 rad8 mt15 alertRed noborder underline mr20",
                style: {"height":"50px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteCustomNotification && _ctx.deleteCustomNotification(...args)))
              }, " 削除 ")
            ]),
            _hoisted_28,
            (_ctx.provider == `webhook` && _ctx.notiDic.settings.token)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("p", null, [
                    _hoisted_30,
                    _createElementVNode("span", null, _toDisplayString(_ctx.notiDic.settings.token), 1),
                    _createVNode(_component_tooltip, {
                      text: "コピーしました!",
                      trigger: "manual",
                      modelValue: _ctx.showTip,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showTip) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/copy_icon.png`),
                          width: "17",
                          height: "17",
                          class: "ml4 pointer",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyToken && _ctx.copyToken(...args)))
                        }, null, 8, _hoisted_31)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15",
                    style: {"height":"40px"},
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateWebhookToken && _ctx.updateWebhookToken(...args)))
                  }, " 検証用トークンを更新 ")
                ]))
              : _createCommentVNode("", true),
            _hoisted_32
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_33
  ]))
}